import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { Card, Row, Col, FormInstance, Form } from 'antd';
import { InvoicePartFormValues } from '../InvoicePartForm.types';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';

interface Props {
  form: FormInstance<InvoicePartFormValues>;
}

const InvoicePartIrpjCsllForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Card title="IRRF" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[24, 16]}>
          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'irpjCsll', 'irrfWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'irpjCsll', 'irrfWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Base cálculo"
              name={['itemTaxes', 'irpjCsll', 'irrfBaseCalculationValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>

      <Card title="CSLL" type="inner" style={{ marginBottom: 24 }}>
        <Row gutter={[24, 16]}>
          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Alíquota"
              name={['itemTaxes', 'irpjCsll', 'csllWithheldRate']}
            >
              <InputDecimal fractions={4} max={100} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Valor"
              name={['itemTaxes', 'irpjCsll', 'csllWithheldValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Base cálculo"
              name={['itemTaxes', 'irpjCsll', 'csllBaseCalculationValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default InvoicePartIrpjCsllForm;
